import { useAutocomplete } from 'admin';
import { getInternalMaterialProductName, type MaterialProductInfoListItem } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialAutocompleteProps = {
  defaultValue?: MaterialProductInfoListItem['id'];
  country?: string;
  material_grade_id?: number;
  material_spec_id?: number;
} & Omit<AutocompleteFieldProps<MaterialProductInfoListItem>, 'options' | 'defaultValue'>;

export const MaterialProductAutocomplete = ({
  defaultValue,
  country,
  material_grade_id,
  material_spec_id,
  ...props
}: MaterialAutocompleteProps) => {
  const { autocompleteProps } = useAutocomplete<MaterialProductInfoListItem>({
    defaultValue: defaultValue,
    filters: [
      {
        field: 'country',
        operator: 'eq',
        value: country,
      },
      {
        field: 'material_grade_id',
        operator: 'eq',
        value: material_grade_id,
      },
      {
        field: 'material_spec_id',
        operator: 'eq',
        value: material_spec_id,
      },
    ],
    pagination: {
      pageSize: 100,
    },
    resource: '/materials/v1/material-products/',
  });

  return (
    <AutocompleteField<MaterialProductInfoListItem>
      {...props}
      {...autocompleteProps}
      getOptionLabel={(option) => {
        if (typeof option === 'number') {
          return '';
        }
        return getInternalMaterialProductName(option);
      }}
      filterOptions={(options, state) =>
        options.filter((option) =>
          getInternalMaterialProductName(option).toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
      valueField="id"
      data-testid="material-product-autocomplete"
    />
  );
};
